export const DueDiligenceFormTitles = [
  { title: 'Operational and Compliance', fieldsTitle: 'initialDueDiligenceFields' },
  { title: 'Licensure and Regulatory', fieldsTitle: 'licensureAndRegulatoryFields' },
  { title: 'Employee Matters/Benefits', fieldsTitle: 'employeeMattersAndBenefitsFields' },
  { title: 'General Governance', fieldsTitle: 'generalGovernanceFields' },
  { title: 'Real Estate', fieldsTitle: 'realEstateFields' },
  { title: 'Litigation', fieldsTitle: 'litigationFields' },
  { title: 'Contracts', fieldsTitle: 'contractsFields' },
  { title: 'Financials', fieldsTitle: 'financialFields' },
  { title: 'Physical Plant/Capital Expenditures Items', fieldsTitle: 'physicalPlantAndCapitalExpendituresFields' },
  { title: 'Insurance/Risk Management', fieldsTitle: 'insuranceAndRiskManagementFields' },
];

export const FacilityInformationFormTitles = [
  { title: 'General Information', fieldsTitle: 'generalInformationFields' },
  { title: 'Seller Information', fieldsTitle: 'sellerInformationFields' },
  { title: 'Buyer Information', fieldsTitle: 'buyerInformationFields' },
  { title: 'Additional Files', fieldsTitle: 'additionalFilesFields' }, 
  { title: 'Administrative Staff', fieldsTitle: 'administrativeStaffFields' },
]